<!-- <div *ngIf="saving">
	<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
</div> -->

<!-- <div *ngIf="!saving"> -->
<div>
	<div class="grid mb-3" *ngIf="!diagnosticsLogEnabled">
		<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<div class="flex align-items-center justify-content-center flex-wrap gap-1">
				<p-tag icon="pi cm-alert" [value]="('MTMA_DIAG_LOG_NOT_ENABLED' | translate)" severity="warning"></p-tag>
				<p-button *ngIf="online && configured" styleClass="border-0" icon="pi cm-events" size="large" label="{{ 'ENABLE_LOG' | translate }}"
					(click)="enableDiagnosticsLog()" [rounded]="false" [text]="true" severity="secondary">
				</p-button>
			</div>
		</div>
	</div>
	<form [formGroup]="filterGroup">
		<div class="grid mt-0 px-3">
			<div [class]="col6Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'START_DATE_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-calendar [showIcon]="true" formControlName="startDateTime" [showButtonBar]="true"
							placeholder="{{'START_DATE_TIME' | translate}}" id="events-input-deviceFilter"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
							inputStyleClass="pl-6 border-noround-right surface-900" [minDate]="minDate" [maxDate]="maxDate"
							[defaultDate]="today" [showTime]="true" [hourFormat]="24">
						</p-calendar>
					</div>
				</div>
			</div>
			<div [class]="col6Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'END_DATE_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-calendar [showIcon]="true" formControlName="endDateTime" [showButtonBar]="true"
							placeholder="{{'END_DATE_TIME' | translate}}" id="events-input-deviceFilter"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
							inputStyleClass="pl-6 border-noround-right surface-900" [minDate]="minDate" [defaultDate]="today"
							[maxDate]="maxDate" [showTime]="true" [hourFormat]="24">
						</p-calendar>
					</div>
				</div>
			</div>
			<div [class]="col6Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'MTMA_DIAG_FILTER_EVENT_TYPE' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-dropdown formControlName="eventType" [options]="eventTypeOptions" optionLabel="label" optionValue="value"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 surface-900"
							id="mtma-diag-filter-event-type" [showClear]="true" appendTo="body">
							<ng-template let-item pTemplate="selectedItem">
								<div class="item flex align-items-center justify-content-center">
									<div class="flex align-items-center">{{ item.label | translate }}</div>
								</div>
							</ng-template>
							<ng-template let-section pTemplate="item">
								<div class="item flex justify-content-center">
									<div>{{ section.label | translate }}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
			</div>
			<div [class]="col6Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'MTMA_DIAG_FILTER_EVENT_SUBTYPE' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-dropdown formControlName="eventSubType" [options]="eventSubTypeOptions" optionLabel="label" optionValue="value"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 surface-900"
							id="mtma-diag-filter-event-subtype" [showClear]="true" appendTo="body">
							<ng-template let-item pTemplate="selectedItem">
								<div class="item flex align-items-center justify-content-center">
									<div class="flex align-items-center">{{ item.label | translate }}</div>
								</div>
							</ng-template>
							<ng-template let-section pTemplate="item">
								<div class="item flex justify-content-center">
									<div>{{ section.label | translate }}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
			</div>
			<div class="col-12">
				<div *ngIf="!onExtendedMobile()" class="flex justify-content-center gap-4">
					<p-button icon="pi cm-reload" label="{{ 'REQUEST_GENERAL_STATE' | translate }}" (click)="diagnosticsStateRefresh()" [rounded]="false" [text]="true"
						severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-full w-16rem">
					</p-button>
					<p-button icon="pi cm-reload" label="{{ 'REFRESH' | translate }}" (click)="refresh()" [rounded]="false" [text]="true"
						severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-16rem">
					</p-button>
				</div>
				
				<div *ngIf="onExtendedMobile()" class="col-12 pt-0">
					<div class="col-12 px-0">
						<p-button label="{{ 'REQUEST_GENERAL_STATE' | translate }}" (click)="diagnosticsStateRefresh()" [rounded]="false" [text]="true"
							severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-full">
						</p-button>
					</div>
					<div class="col-12 px-0">
						<p-button icon="pi cm-reload" label="{{ 'REFRESH' | translate }}" (click)="refresh()" [rounded]="false" [text]="true"
							severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900 w-full">
						</p-button>
					</div>
				</div>
			</div>
		</div>
	</form>

	<div class="grid mt-0">
		<div class="col-12">
			<div class="card border-round">
				<p-table #tableCallUnitEventList dataKey="Id" [value]="logs" [totalRecords]="resultLength" [rows]="pageSize"
					[lazy]="true" [loading]="logsLoading || mtmaDiagnosticsLogAction" [paginator]="true" (onLazyLoad)="loadLogs($event)"
					[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
					sortField="Id" [sortOrder]="-1" responsiveLayout="stack">
					<ng-template pTemplate="header">
						<tr>
							<th style="width: 5rem"></th>
							<th>
								<!-- <div pSortableColumn="EventDate" class="flex align-items-center justify-content-center"> -->
								<div class="flex align-items-center justify-content-center">
									{{ 'DATE' | translate }}
									<!-- <p-sortIcon field="EventDate"></p-sortIcon> -->
								</div>
							</th>
							<th>
								<!-- <div pSortableColumn="EventType" class="flex align-items-center justify-content-center"> -->
								<div class="flex align-items-center justify-content-center">
									{{ 'TYPE' | translate }}
								</div>
							</th>
							<th>
								<!-- <div pSortableColumn="EventSubType" class="flex align-items-center justify-content-center"> -->
								<div class="flex align-items-center justify-content-center">
									{{ 'EVENT' | translate }}
								</div>
							</th>
							<th>
								<!-- <div pSortableColumn="Value" class="flex align-items-center justify-content-center"> -->
								<div class="flex align-items-center justify-content-center">
									{{ 'DESCRIPTION' | translate }}
								</div>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-row let-expanded="expanded">
						<tr>
							<td>
								<p-button *ngIf="row.Type === MtmaDiagnosticsEventType.Info && row.SubType === 0" [pRowToggler]="row" [rounded]="true"
									styleClass="surface-900 hover:bg-primary border-1 border-600"
									[icon]="expanded ? 'pi cm-angle-down' : 'pi cm-angle-right'" />
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'DATE' | translate }}</span>{{
								getDate(row.EventDate) |
								localizedDate: 'medium':'UTC' }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'TYPE' | translate }}</span>
								<ng-container [ngSwitch]="row.Type">
									<p-tag *ngSwitchCase="MtmaDiagnosticsEventType.Error" icon="pi pi-times" severity="danger"
										value="{{ 'MTMA_CONF_{Error}' | translate }}"></p-tag>
									<p-tag *ngSwitchCase="MtmaDiagnosticsEventType.Info" icon="pi pi-info" severity="info"
										value="{{ 'MTMA_CONF_{Information}' | translate }}"></p-tag>
									<span *ngSwitchDefault>{{ row.Type }}</span>
								</ng-container>
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'EVENT' | translate }}</span>{{ displaySubType(row) }}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'DESCRIPTION' | translate }}</span>
								<div *ngIf="row.Type !== MtmaDiagnosticsEventType.Info || row.SubType !== 0">
									{{ displayValue(row) }}
								</div>
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="emptymessage">
						<tr>
							<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="rowexpansion" let-row>
						<tr class="surface-400">
							<td colspan="5">
								<div class="w-full overflow-x-auto" [class]="onExtendedMobile() ? 'px-2' : ''">
									<ng-container *ngIf="hasValidDiagnosticsValueJson(row); else diagnosticsJsonInvalid">
										<p-table [value]="getDiagnosticsValueTableData(row)" [paginator]="false"
											[autoLayout]="true" responsiveLayout="stack">
											<ng-template pTemplate="header">
												<tr>
													<th>{{ 'MTMA_DIAG_VALUE_COL_SIM_PIN_STATE' | translate }}</th>
													<!-- <th>{{ 'MTMA_DIAG_VALUE_COL_SIM_PIN_STORED' | translate }}</th> -->
													<th>{{ 'MTMA_DIAG_VALUE_COL_APN_STORED' | translate }}</th>
													<th>{{ 'MTMA_DIAG_VALUE_COL_OPERATOR' | translate }}</th>
													<th>{{ 'MTMA_DIAG_VALUE_COL_SIGNAL_LEVEL' | translate }}</th>
													<th>{{ 'MTMA_DIAG_VALUE_COL_CONNECTIVITY_TYPE' | translate }}</th>
													<!-- <th>{{ 'MTMA_DIAG_VALUE_COL_CC_CONNECTION' | translate }}</th> -->
													<th>{{ 'MTMA_DIAG_VALUE_COL_VOLTE_STATE' | translate }}</th>
													<th>{{ 'MTMA_DIAG_VALUE_COL_TIMEZONE_STORED' | translate }}</th>
													<th>{{ 'LOG_CALLS' | translate }}</th>
													<th>{{ 'ACCESS_LOG' | translate }}</th>
													<th>{{ 'LOG_DIAGNOSTICS' | translate }}</th>
												</tr>
											</ng-template>
											<ng-template pTemplate="body" let-expandedRow>
												<tr>
													<td>
														<span class="p-column-title font-semibold">{{ 'MTMA_DIAG_VALUE_COL_SIM_PIN_STATE' | translate }}</span>
														<div class="flex align-items-center justify-content-center" [ngSwitch]="diagnosticsBinaryTagKind(expandedRow['SimPinEn'])">
															<i *ngSwitchCase="'off'" class="pi pi-times text-xl text-red-700" aria-hidden="true"></i>
															<i *ngSwitchCase="'on'" class="pi pi-check text-xl text-green-600" aria-hidden="true"></i>
															<span *ngSwitchDefault>{{ formatDiagnosticsJsonValue(expandedRow['SimPinEn']) }}</span>
														</div>
													</td>
													<!-- <td><span class="p-column-title font-semibold">{{ 'MTMA_DIAG_VALUE_COL_SIM_PIN_STORED' | translate }}</span>
														{{ formatDiagnosticsJsonValue(expandedRow['SimPin']) }}</td> -->
													<td><span class="p-column-title font-semibold">{{ 'MTMA_DIAG_VALUE_COL_APN_STORED' | translate }}</span>
														{{ formatDiagnosticsJsonValue(expandedRow['Apn']) }}</td>
													<td><span class="p-column-title font-semibold">{{ 'MTMA_DIAG_VALUE_COL_OPERATOR' | translate }}</span>
														{{ formatDiagnosticsJsonValue(expandedRow['Operator']) }}</td>
													<td><span class="p-column-title font-semibold">{{ 'MTMA_DIAG_VALUE_COL_SIGNAL_LEVEL' | translate }}</span>
														{{ formatDiagnosticsSignalLevel(expandedRow['SignalLevel']) }}</td>
													<td>
														<span class="p-column-title font-semibold">{{ 'MTMA_DIAG_VALUE_COL_CONNECTIVITY_TYPE' | translate }}</span>
														<ng-container *ngIf="diagnosticsNetModeTag(expandedRow['NetMode']) as netModeTag; else netModePlain">
															<span class="font-semibold"
																[ngClass]="netModeTag.severity === 'danger' ? 'text-red-700' : 'text-green-600'">{{ netModeTag.label }}</span>
														</ng-container>
														<ng-template #netModePlain>
															<span>{{ formatDiagnosticsJsonValue(expandedRow['NetMode']) }}</span>
														</ng-template>
													</td>
													<!-- <td>
														<span class="p-column-title font-semibold">{{ 'MTMA_DIAG_VALUE_COL_CC_CONNECTION' | translate }}</span>
														<ng-container [ngSwitch]="diagnosticsBinaryTagKind(expandedRow['CcEn'])">
															<i *ngSwitchCase="'off'" class="pi pi-times text-xl text-red-700" aria-hidden="true"></i>
															<i *ngSwitchCase="'on'" class="pi pi-check text-xl text-green-600" aria-hidden="true"></i>
															<span *ngSwitchDefault>{{ formatDiagnosticsJsonValue(expandedRow['CcEn']) }}</span>
														</ng-container>
													</td> -->
													<td>
														<span class="p-column-title font-semibold">{{ 'MTMA_DIAG_VALUE_COL_VOLTE_STATE' | translate }}</span>
														<ng-container [ngSwitch]="diagnosticsBinaryTagKind(expandedRow['VolteEn'])">
															<i *ngSwitchCase="'off'" class="pi pi-times text-xl text-red-700" aria-hidden="true"></i>
															<i *ngSwitchCase="'on'" class="pi pi-check text-xl text-green-600" aria-hidden="true"></i>
															<span *ngSwitchDefault>{{ formatDiagnosticsJsonValue(expandedRow['VolteEn']) }}</span>
														</ng-container>
													</td>
													<td>{{ formatDiagnosticsJsonValue(expandedRow['Timezone']) }}</td>
													<td>
														<span class="p-column-title font-semibold">{{ 'LOG_CALLS' | translate }}</span>
														<ng-container [ngSwitch]="diagnosticsBinaryTagKind(expandedRow['CallEventEn'])">
															<i *ngSwitchCase="'off'" class="pi pi-times text-xl text-red-700" aria-hidden="true"></i>
															<i *ngSwitchCase="'on'" class="pi pi-check text-xl text-green-600" aria-hidden="true"></i>
															<span *ngSwitchDefault>{{ formatDiagnosticsJsonValue(expandedRow['CallEventEn']) }}</span>
														</ng-container>
													</td>
													<td>
														<span class="p-column-title font-semibold">{{ 'ACCESS_LOG' | translate }}</span>
														<ng-container [ngSwitch]="diagnosticsBinaryTagKind(expandedRow['AccessEventEn'])">
															<i *ngSwitchCase="'off'" class="pi pi-times text-xl text-red-700" aria-hidden="true"></i>
															<i *ngSwitchCase="'on'" class="pi pi-check text-xl text-green-600" aria-hidden="true"></i>
															<span *ngSwitchDefault>{{ formatDiagnosticsJsonValue(expandedRow['AccessEventEn']) }}</span>
														</ng-container>
													</td>
													<td>
														<span class="p-column-title font-semibold">{{ 'LOG_DIAGNOSTICS' | translate }}</span>
														<ng-container [ngSwitch]="diagnosticsBinaryTagKind(expandedRow['SystemLogEn'])">
															<i *ngSwitchCase="'off'" class="pi pi-times text-xl text-red-700" aria-hidden="true"></i>
															<i *ngSwitchCase="'on'" class="pi pi-check text-xl text-green-600" aria-hidden="true"></i>
															<span *ngSwitchDefault>{{ formatDiagnosticsJsonValue(expandedRow['SystemLogEn']) }}</span>
														</ng-container>
													</td>
												</tr>
											</ng-template>
										</p-table>
									</ng-container>
									<ng-template #diagnosticsJsonInvalid>
										<span class="text-sm">{{ row.Value }}</span>
									</ng-template>
								</div>
							</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
		</div>
	</div>
</div>

<!-- <p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton *ngIf="rejectButtonVisible" [label]="confDialog.rejectButtonLabel"
				[ngClass]="rejectButtonStyle" (click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog> -->